// Angular ErrorHandler that routes uncaught errors through the telemetry seam
// to OpenObserve RUM. Replaces Sentry.createErrorHandler(). Errors are still
// logged to the console so local debugging is unaffected.

import { ErrorHandler, Injectable } from '@angular/core';
import { telemetry } from './telemetry';

@Injectable()
export class OpenObserveErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    // Angular wraps the original error; unwrap rxjs/zone "originalError" if present.
    const original = (error as { ngOriginalError?: unknown })?.ngOriginalError ?? error;

    telemetry.captureException(original, {
      tags: { source: 'angular_error_handler' }
    });

    console.error(original);
  }
}
